export const REST_GRAPHQL_CLIENTNAME = 'restGraphQl';
